module.exports = __webpack_public_path__ + "assets/img/17.a199668a.png";